"use client";

interface SuggestionItem {
  label: string;
  message: string;
}

interface ChatSuggestionBoxProps {
  suggestions: SuggestionItem[];
  onSendMessage: (message: string) => void;
  category?: string;
  disabled?: boolean;
}

export function ChatSuggestionBox({
  suggestions,
  onSendMessage,
  category = "default",
  disabled = false,
}: ChatSuggestionBoxProps) {
  return (
    <div className="w-full max-w-3xl mx-auto min-h-[200px]">
      <div className="relative">
        {suggestions.map((suggestion, index) => (
          <div
            key={`${category}-${index}`}
            onClick={() => !disabled && onSendMessage(suggestion.message)}
            className={`
              px-4 py-3 text-left transition-colors duration-200
              ${index < suggestions.length - 1 ? "border-b border-gray-200 " : ""}
              ${disabled
                ? "opacity-50 cursor-not-allowed pointer-events-none text-foreground"
                : "cursor-pointer text-foreground hover:text-primary-600"
              }
            `}
          >
            {suggestion.label}
          </div>
        ))}
      </div>
    </div>
  );
}
